"use strict";

/*
 * Created by Cosmo Cochrane on 4/20/17.
 * Copyright (c) 2017 Giphy Inc.
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/.
 */

var TermSuggestion = function TermSuggestion(data) {
  return {
    "term": data.name ? data.name : null
  };
};

module.exports = TermSuggestion;